import { Divider } from "@material-ui/core";
import React, { useState } from "react";

const SystemDefault = () => {
  const [selectedTab, setSelectedTab] = useState("General");
  const [formData, setFormData] = useState({
    maxWager: 0,
    minWager: 0,
    maxWagerOnline: 0,
    minWagerOnline: 0,
    settleAmount: 0,
    softLimitPercent: 0,
    actionPointsMax: 0,
    chart: 0,
    masterChart: 0,
    lineStyle: "",
    flagMessage: "",
    onlineMessage: "",
    status: "Enabled",
    baseballLine: "Normal",
    hockeyLine: "American",
    scheduleStyle: "European",
    enableSports: false,
    enableCasino: false,
    enableHorses: false,
    enableCards: true,
    playerPlaysInTicker: false,
    master: false,
    online: false,
  });
  
  const [enableSports, setEnableSports] = useState(false);
  const [enableCasino, setEnableCasino] = useState(false);
  const [enableHorses, setEnableHorses] = useState(false);
  const [enableCards, setEnableCards] = useState(true);
  const [playerPlaysInTicker, setPlayerPlaysInTicker] = useState(false);
  const [master, setMaster] = useState(false);
  const [online, setOnline] = useState(false);

  const [maxWager, setMaxWager] = useState(0);
  const [minWager, setMinWager] = useState(0);
  const [maxWagerOnline, setMaxWagerOnline] = useState(0);
  const [minWagerOnline, setMinWagerOnline] = useState(0);
  const [settleAmount, setSettleAmount] = useState(0);
  const [softLimitPercent, setSoftLimitPercent] = useState(0);
  const [actionPointsMax, setActionPointsMax] = useState(0);
  const [chart, setChart] = useState(0);
  const [masterChart, setMasterChart] = useState(0);

  const [agent, setAgent] = useState("");
  const [profile, setProfile] = useState("ZZZDEL1011");
  const [limitsProfile, setLimitsProfile] = useState("...");
  const [lineType, setLineType] = useState("1 DEFAULT");
  const [currency, setCurrency] = useState("USD");
  const [office, setOffice] = useState("HOUSE - BB");
  const [grouping, setGrouping] = useState("");
  const [playerRating, setPlayerRating] = useState("UNRATED");
  const [flagType, setFlagType] = useState("WELCOME");
  const [timeZone, setTimeZone] = useState("USA PacificPlus");
  const [language, setLanguage] = useState("English");
  const [bonusStart, setBonusStart] = useState("2008-11-10");
  const [bonusExpires, setBonusExpires] = useState("2008-11-10");

   const [profiles, setProfiles] = useState([]);
   const [idProfile, setIdProfile] = useState("");

  const [dataRadios, setDataRadios] = useState([
    { name: "status", options: ["Enabled", "Disabled"] },
    { name: "baseballLine", options: ["Normal", "Wide", "New York"] },
    { name: "hockeyLine", options: ["American", "Canadian"] },
    { name: "scheduleStyle", options: ["European", "American"] },
    ])

    const options = {
        agent: ["Agent 1", "Agent 2", "Agent 3"],
        profile: ["Profile A", "Profile B", "Profile C"],
        limitsProfile: ["Low", "Medium", "High"],
        lineType: ["Type 1", "Type 2", "Type 3"],
        currency: ["USD", "EUR", "GBP"],
        office: ["Office 1", "Office 2", "Office 3"],
        grouping: ["Group A", "Group B", "Group C"],
        playerRating: ["Bronze", "Silver", "Gold"],
        flagType: ["Flag 1", "Flag 2", "Flag 3"],
        timeZone: ["UTC-5", "UTC+0", "UTC+3"],
        language: ["English", "Spanish", "French"]
      };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  function changeProfileId(value) {
    setIdProfile(value);
  }

  return (
    <div className="MuiTable-root2">
      <h2>System Defaults</h2>
      <Divider className="mt-4 mb-4"></Divider>
        <select
          className="w-full lg:w-auto lg:flex-1 max-w-[300px] border border-gray-300 rounded px-2 py-1 h-[40px] text-xs mb-3"
          name="Profile"
          onChange={(e) => changeProfileId(e.target.value)}
          defaultValue={-5}
        >
          <option value="-5" disabled>
           Select an option
          </option>
          {profiles.map((profile) => (
            <option key={profile.profileID} value={profile.profileID}>
              {profile.profileName}
            </option>
          ))}
        </select>
       <div className="p-4 border rounded-lg bg-gray-50 w-full text-xs">

        <div className="flex border-b mb-2">
            <button
            className={`px-3 py-1 ${selectedTab === "General" ? "bg-gray-300" : "bg-white"}`}
            onClick={() => setSelectedTab("General")}
            >
            General
            </button>
            <button
            className={`px-3 py-1 ${selectedTab === "Other" ? "bg-gray-300" : "bg-white"}`}
            onClick={() => setSelectedTab("Other")}
            >
            Other
            </button>
        </div>
        {selectedTab === "General" && (
            <div>
                <div className="grid grid-cols-2 gap-3 border-b  pb-4">
                    <div className="grid grid-cols-1 gap-4">
                    {[{ label: "Max Wager", state: maxWager, setState: setMaxWager },
                        { label: "Min Wager", state: minWager, setState: setMinWager },
                        { label: "Max Wager Online", state: maxWagerOnline, setState: setMaxWagerOnline },
                        { label: "Min Wager Online", state: minWagerOnline, setState: setMinWagerOnline },
                        { label: "Settle Amount", state: settleAmount, setState: setSettleAmount },
                        { label: "Soft Limit Percent", state: softLimitPercent, setState: setSoftLimitPercent },
                        { label: "Action Points Max", state: actionPointsMax, setState: setActionPointsMax },
                        { label: "Chart", state: chart, setState: setChart },
                        { label: "Master Chart", state: masterChart, setState: setMasterChart }].map(({ label, state, setState }) => (
                        <div key={label} className="flex w-full">
                        <label className="w-1/3 uppercase font-semibold mb-0 flex items-center">{label}</label>
                        <input
                            type="number"
                            value={state}
                            onChange={(e) => setState(Number(e.target.value))}
                            className="border p-1 w-2/3"
                        />
                        </div>
                    ))}
                    
                    </div>
                    <div className="flex flex-col gap-4">
                        {dataRadios.map((group) => (
                            <div key={group.name} className=" border bg-white rounded-md p-2">
                            <label className="uppercase font-semibold">{group.name.replace(/([A-Z])/g, " $1").trim()}</label>
                            {group.options.map((option) => (
                                <div key={option} className="flex items-center gap-2">
                                <input
                                    type="radio"
                                    name={group.name}
                                    value={option}
                                    checked={formData[group.name] === option}
                                    onChange={handleInputChange}
                                />
                                <span>{option}</span>
                                </div>
                            ))}
                            </div>
                        ))}
                    </div>
                </div>
                <div className="flex flex-col gap-4 pt-4">
                    <div>
                        <label className="uppercase font-semibold mb-1">Line Style</label>
                        <select
                        name="lineStyle"
                        value={formData.lineStyle}
                        onChange={handleInputChange}
                        className="border p-1 w-full"
                        >
                        <option value="">Select Style</option>
                        <option value="Style1">Style 1</option>
                        <option value="Style2">Style 2</option>
                        </select>
                    </div>
                    <div>
                        <label className="uppercase font-semibold mb-1">Flag Message</label>
                        <input
                        type="text"
                        name="flagMessage"
                        value={formData.flagMessage}
                        onChange={handleInputChange}
                        className="border p-1 w-full"
                        />
                    </div>
                    <div className="uppercase font-semibold mb-1">
                        <label>Online Message</label>
                        <input
                        type="text"
                        name="onlineMessage"
                        value={formData.onlineMessage}
                        onChange={handleInputChange}
                        className="border p-1 w-full"
                        />
                    </div>
                    <div className="flex gap-4 py-2 text-xs">
                        <div className="flex flex-col gap-2">
                            <div className="flex items-center gap-2">
                                <input type="checkbox" checked={playerPlaysInTicker} onChange={() => setPlayerPlaysInTicker(!playerPlaysInTicker)} />
                                <span>Player Plays in Ticker</span>
                            </div>
                            <div className="flex items-center gap-2">
                                <input type="checkbox" checked={master} onChange={() => setMaster(!master)} />
                                <span>Master</span>
                            </div>
                            <div className="flex items-center gap-2">
                                <input type="checkbox" checked={online} onChange={() => setOnline(!online)} />
                                <span>Online</span>
                            </div>
                        </div>
                        <div className="flex flex-col gap-2">
                            <div className="flex items-center gap-2">
                                <input type="checkbox" checked={enableSports} onChange={() => setEnableSports(!enableSports)} />
                                <span>Enable Sports</span>
                            </div>
                            <div className="flex items-center gap-2">
                                <input type="checkbox" checked={enableCasino} onChange={() => setEnableCasino(!enableCasino)} />
                                <span>Enable Casino</span>
                            </div>
                            <div className="flex items-center gap-2">
                                <input type="checkbox" checked={enableHorses} onChange={() => setEnableHorses(!enableHorses)} />
                                <span>Enable Horses</span>
                            </div>
                            <div className="flex items-center gap-2">
                                <input type="checkbox" checked={enableCards} onChange={() => setEnableCards(!enableCards)} />
                                <span>Enable Cards</span>
                            </div>
                        </div>
                       
                    </div>
                </div>

            </div>
        )}
        {selectedTab === "Other" && (
           <div className="flex flex-col gap-4">
            {[{ key: "agent", label: "Agent", state: agent, setState: setAgent },
                { key: "profile", label: "Profile", state: profile, setState: setProfile },
                { key: "limitsProfile", label: "Limits Profile", state: limitsProfile, setState: setLimitsProfile },
                { key: "lineType", label: "Line Type", state: lineType, setState: setLineType },
                { key: "currency", label: "Currency", state: currency, setState: setCurrency },
                { key: "office", label: "Office", state: office, setState: setOffice },
                { key: "grouping", label: "Grouping", state: grouping, setState: setGrouping },
                { key: "playerRating", label: "Player Rating", state: playerRating, setState: setPlayerRating },
                { key: "flagType", label: "Flag Type", state: flagType, setState: setFlagType },
                { key: "timeZone", label: "Time Zone", state: timeZone, setState: setTimeZone },
                { key: "languaje", label: "Language", state: language, setState: setLanguage }].map(({ key, label, state, setState }) => (
                <div key={label} className="flex w-full">
                <label className="w-1/3 uppercase font-semibold mb-0 flex items-center">{label}</label>
                {/* <input
                    type="text"
                    value={state}
                    onChange={(e) => setState(e.target.value)}
                    className="border p-1 w-2/3"
                /> */}
                <select
                value={state}
                onChange={(e) => setState(e.target.value)}
                className="border p-1 px-2 w-2/3"
                >
                {/* <option value="">Select</option> */}
                {options[key]?.map((option) => (
                    <option key={option} value={option}>
                    {option}
                    </option>
                ))}
                </select>
                </div>
            ))}
            <div className="col-span-2 border bg-white  py-2 px-4  rounded">
                <h3 className="font-semibold">Bonus Points</h3>
                <div className="flex gap-4">
                <div>
                    <label>Bonus Start On</label>
                    <input type="date" value={bonusStart} onChange={(e) => setBonusStart(e.target.value)} className="border p-1 w-full" />
                </div>
                <div>
                    <label>Bonus Expires</label>
                    <input type="date" value={bonusExpires} onChange={(e) => setBonusExpires(e.target.value)} className="border p-1 w-full" />
                </div>
                </div>
                <div className="mt-2">
                <label>Status</label>
                <div className="flex gap-4">
                    {['Enabled', 'Disabled', 'Banned'].map((option) => (
                    <label key={option} className="flex items-center gap-2">
                        <input type="radio" name="status" value={option} checked={status === option} onChange={(e) => setStatus(e.target.value)} />
                        {option}
                    </label>
                    ))}
                </div>
                </div>
            </div>
            </div>
        )}
       </div>
    </div>
  );
};

export default SystemDefault;
